import { render, staticRenderFns } from "./tRC.vue?vue&type=template&id=7432ec72&scoped=true"
import script from "./tRC.vue?vue&type=script&lang=js"
export * from "./tRC.vue?vue&type=script&lang=js"
import style0 from "./tRC.vue?vue&type=style&index=0&id=7432ec72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7432ec72",
  null
  
)

export default component.exports